// Canonical storage is metric (kg, cm, ml). Helpers convert for display/input.
export const KG_PER_LB = 0.45359237;
export const CM_PER_IN = 2.54;

export const kgToLb = (kg) => kg / KG_PER_LB;
export const lbToKg = (lb) => lb * KG_PER_LB;
export const cmToIn = (cm) => cm / CM_PER_IN;
export const inToCm = (inches) => inches * CM_PER_IN;

export const round1 = (n) => Math.round(n * 10) / 10;

// weight display
export function weightForDisplay(kg, system) {
  if (kg == null || kg === "") return "";
  return system === "imperial" ? round1(kgToLb(kg)) : round1(kg);
}
export function weightToMetric(value, system) {
  const v = parseFloat(value);
  if (isNaN(v)) return "";
  return system === "imperial" ? round1(lbToKg(v)) : round1(v);
}

// height in imperial split to ft/in
export function cmToFtIn(cm) {
  const totalIn = cmToIn(cm);
  const ft = Math.floor(totalIn / 12);
  const inch = Math.round(totalIn - ft * 12);
  return { ft, inch };
}
export function ftInToCm(ft, inch) {
  const f = parseInt(ft || 0, 10);
  const i = parseFloat(inch || 0);
  return round1(inToCm((isNaN(f) ? 0 : f) * 12 + (isNaN(i) ? 0 : i)));
}

// weight in stones + pounds (UK)
export function kgToStone(kg) {
  const totalLb = kgToLb(kg);
  let st = Math.floor(totalLb / 14);
  let lb = Math.round(totalLb - st * 14);
  if (lb === 14) { st += 1; lb = 0; }
  return { st, lb };
}
export function stoneToKg(st, lb) {
  const s = parseInt(st || 0, 10);
  const l = parseFloat(lb || 0);
  return round1(lbToKg((isNaN(s) ? 0 : s) * 14 + (isNaN(l) ? 0 : l)));
}

export const weightUnit = (system) => (system === "imperial" ? "lb" : "kg");
export const heightUnit = (system) => (system === "imperial" ? "ft/in" : "cm");

// fluid display: metric ml -> imperial fl oz
export function fluidForDisplay(ml, system) {
  if (ml == null) return 0;
  return system === "imperial" ? Math.round(ml / 29.5735) : Math.round(ml);
}
export const fluidUnit = (system) => (system === "imperial" ? "fl oz" : "ml");

// Hydration is ALWAYS shown in litres, regardless of unit system.
export function litresLabel(ml) {
  const l = Number(ml || 0) / 1000;
  const s = l.toFixed(2).replace(/\.?0+$/, "");
  return `${s}L`;
}
